function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00001 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00001 1.33331C4.31811 1.33331 1.33334 4.31808 1.33334 7.99998C1.33334 11.6819 4.31811 14.6666 8.00001 14.6666Z",
  fill: "#A8B0C1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.80447 4C9.05971 4 9.2558 4.07188 9.39431 4.21563C9.53282 4.35938 9.6013 4.54375 9.6013 4.76719C9.6013 5.03437 9.49703 5.26875 9.29004 5.47187C9.08305 5.675 8.83093 5.77656 8.53367 5.77656C8.27844 5.77656 8.08234 5.70781 7.94383 5.56875C7.80532 5.42969 7.74151 5.2375 7.75241 4.99219C7.75241 4.74688 7.84578 4.52031 8.03098 4.3125C8.21619 4.10469 8.47453 4 8.80447 4ZM7.16256 12C6.63186 12 6.48868 11.525 6.73302 10.5766L7.21081 8.54531C7.28551 8.24687 7.28551 8.09688 7.21081 8.09688C7.147 8.09688 7.00382 8.14531 6.78127 8.24062C6.55872 8.33594 6.36729 8.4375 6.20699 8.54531L6 8.19375C6.47779 7.77812 6.98048 7.44219 7.50651 7.18594C8.03254 6.92969 8.43407 6.80156 8.70954 6.80156C9.12351 6.80156 9.22001 7.23281 8.9959 8.09688L8.43874 10.225C8.35314 10.5656 8.37026 10.7375 8.48698 10.7375C8.72043 10.7375 9.03481 10.5781 9.427 10.2578L9.66667 10.5781C9.22001 11.0375 8.75623 11.3891 8.27221 11.6344C7.7882 11.8797 7.4178 12 7.16256 12Z",
  fill: "white"
});

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.150aed3c.svg";
export { ForwardRef as ReactComponent };